import MatrizEvaluacionPuesto from "./MatrizEvaluacionPuesto";
import Admin from "./admin/Admin";
import Criticidad from "./admin/Criticidad";
import FactoresCriticidad from "./admin/FactoresCriticidad";
import TipoCriticidad from "./admin/TipoCriticidad";
import ResumenEvaluacionPuesto  from "../../components/Carrera_Sucesion/ResumenEvaluacionPuesto";
import MatrizSucesion from "./MatrizSucesion";
import Curso from "./admin/Cursos";
import CursoFun from "./admin/CursosFuncion";
import Criterio from "./admin/Criterios";
import FactorCriterio from "./admin/FactoresCriterios"
import FactorResponsable from "./admin/FactoresResponsables";
import MenuPlanCarrera from "./MenuPlanCarrera";
// import PlanCarreraIndividual from "./PlanCarreraIndividual";
const CarreraSucesionRouter = [
  {
    type: "private",
    path: "/sucesion/admin",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: Admin,
    exact: true,
  },
  
  {
    type: "private",
    path: "/sucesion/tipo-criticidad",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: TipoCriticidad,
    exact: true,
  },
  /* {
    type: "private",
    path: "/sucesion/criticidad",
    roles: ["administrador"],
    component: Criticidad,
    exact: true,
  }, */
  {
    type: "private",
    path: "/sucesion/factores-criticidad",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: FactoresCriticidad,
    exact: true,
  },
  
  {
    type: "private",
    path: "/sucesion/matriz-de-evaluación-de-puesto",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: MatrizEvaluacionPuesto,
    exact: true,
  },
  {
    type: "private",
    path: "/sucesion/resumen-evaluacion-de-puesto",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: ResumenEvaluacionPuesto,
  },

  {
    type: "private",
    path: "/sucesion/cursos",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: Curso,
    exact: true,
  },
  {
    type: "private",
    path: "/sucesion/matriz-sucecion",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: MatrizSucesion,
    exact: true,
  },
  {
    type: "private",
    path: "/sucesion/cursos-funcion",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: CursoFun,
    exact: true,
  },
  {
    type: "private",
    path: "/sucesion/criterios",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: Criterio,
    exact: true,
  },
  {
    type: "private",
    path: "/sucesion/factores-criterios",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: FactorCriterio,
    exact: true,
  },
  {
    type: "private",
    path: "/sucesion/factores-responsables",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: FactorResponsable,
    exact: true,
  },
  {
    type: "private",
    path: "/sucesion/plan-de-carrera-individual/:idMatriz/:codigoTitular/:idTitular",
    roles: ["administrador", "Responsable_Carrera_Sucesion"],
    component: MenuPlanCarrera,
    exact: false,
  },
  // {
  //   type: "private",
  //   path: "/sucesion/plan-individal",
  //   roles: ["administrador"],
  //   component: PlanCarreraIndividual,
  //   exact: true,
  // },

];

export default CarreraSucesionRouter;
